/**
 * @see https://umijs.org/docs/max/access#access
 */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const isSuperAdmin = currentUser?.roles?.some((role) => role.roleCode === 'SUPER_ADMIN');
  const isSales = currentUser?.roles?.some((role) => role.roleCode === 'SALES');
  const canManageBackdoor =
    !!isSuperAdmin || !!currentUser?.permissions?.includes('backdoor.manage');

  return {
    canSuperAdmin: isSuperAdmin,
    canViewStatistics: currentUser?.permissions?.includes('statistics.view'),
    canManageUser: currentUser?.permissions?.includes('user.manage'),
    canUserSoftwareManagement: currentUser?.permissions?.includes('user.userSoftwareManage'),
    canManageDepartment: currentUser?.permissions?.includes('department.manage'),
    canManageSoftware: currentUser?.permissions?.includes('software.manage'),
    canManageDevice: currentUser?.permissions?.includes('device.manage'),
    canManageAuthorization: currentUser?.permissions?.includes('authorization.manage'),
    canManageRole: currentUser?.permissions?.includes('role:manage'),
    canManageNotification: currentUser?.permissions?.includes('notification.manage'),
    canManageBackdoor: canManageBackdoor,
    canViewSalesPage: !!isSales,
    canAccessSoftwareMenu:
      currentUser?.permissions?.includes('software.manage') ||
      currentUser?.permissions?.includes('device.manage') ||
      currentUser?.permissions?.includes('authorization.manage'),
  };
}
